import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: null,
    siteLoader: false,
    isAuthenticated: !!localStorage.getItem("access_token"),
    access_token: localStorage.getItem("access_token") || null,
    refresh_token: localStorage.getItem("refresh_token") || null,
};

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        loadAuth: (state, { payload }) => {
            const { access_token, refresh_token } = payload;
            localStorage.setItem("access_token", access_token)
            localStorage.setItem("refresh_token", refresh_token)
            return {
                ...state,
                access_token,
                refresh_token,
                isAuthenticated: true,
            }
        },
        logout: () => {
            localStorage.clear();
            return {
                ...initialState
            }
        },
        handleSiteLoader: (state, { payload }) => {
            return {
                ...state,
                siteLoader: payload,
            };
        }
    },
});

export const { loadAuth, logout, handleSiteLoader } = authSlice.actions;
export default authSlice.reducer;